import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs, { Dayjs } from "dayjs";

export interface MemberFiltersState {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  activeMembersDays: boolean;
  gender: string;
  membershipType: string;
  isNewMember: boolean;
  membership: string;
  minAge: number;
  maxAge: number;
  subscriptionStartDate: Dayjs | null;
  expiryDate: Dayjs | null;
  expertise: string[];
  dietary: string[];
  interests: string[];
  onlyLoggedIn: boolean;
  notCreatedOrder: boolean;
  expiringInDays: boolean;
  newSignupMembers: boolean;
  subscriptionType: string;
  inactiveMembers: boolean;
  activeMembers: boolean;
}

const initialState: MemberFiltersState = {
  startDate: null,
  endDate: null,
  activeMembersDays: false,
  gender: "",
  membershipType: "",
  isNewMember: false,
  membership: "",
  minAge: 0,
  maxAge: 100,
  subscriptionStartDate: null,
  expiryDate: null,
  expertise: [],
  dietary: [],
  interests: [],
  onlyLoggedIn: false,
  notCreatedOrder: false,
  expiringInDays: false,
  newSignupMembers: false,
  subscriptionType: "",
  inactiveMembers: false,
  activeMembers: false,
};

// Helper for loading persisted state
const persisted = localStorage.getItem("memberFilters");
const persistedState = persisted ? JSON.parse(persisted) : initialState;

const memberFiltersSlice = createSlice({
  name: "memberFilters",
  initialState: persistedState,
  reducers: {
    setMemberFilters: (
      state,
      action: PayloadAction<Partial<MemberFiltersState>>
    ) => {
      Object.assign(state, action.payload);
      localStorage.setItem("memberFilters", JSON.stringify(state));
    },
    resetMemberFilters: () => {
      localStorage.removeItem("memberFilters");
      return initialState;
    },
  },
});

export const { setMemberFilters, resetMemberFilters } =
  memberFiltersSlice.actions;
export default memberFiltersSlice.reducer;
